import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconContacts: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconContacts"><Path fillRule="evenodd" clipRule="evenodd" d="M4 22V2H20V19H6V20H20V22H4ZM12 7C11.0335 7 10.25 7.7835 10.25 8.75C10.25 9.7165 11.0335 10.5 12 10.5C12.9665 10.5 13.75 9.7165 13.75 8.75C13.75 7.7835 12.9665 7 12 7ZM15 14H9C9 12.25 9.97873 11.25 12 11.25C13.938 11.25 15 12.25 15 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconContacts;
